import { mergeClassNames, translateToSelectedMountBundle } from '../../../utils';
import { quoteActionTypes, useQuote } from '../../../context/Quote';

import BundledProducts from './BundledProducts';
import MainProduct from './MainProduct';
import React from 'react';
import styles from './index.module.scss';
import { useQuoteVisibility } from '../../../context/QuoteVisbility';
import { useTrackCustomEvent } from '../../../utils/useTrackCustomEvent';

// import ProductListContent from '../../ProductList/ProductListContent';

export default function BundleCard({ bundle, className = null, style = null }) {
  let trackCustomEvent = useTrackCustomEvent();
  let { dispatchQuote } = useQuote();
  const { toggleQuote } = useQuoteVisibility();

  let { product, productMounts, includedProducts } = bundle;
  includedProducts = includedProducts || [];

  const bundleVersions = translateToSelectedMountBundle(bundle);

  let addProduct = mountId => {
    const selectedBundle =
      bundleVersions.find(bundleVersion => {
        return bundleVersion.selectedMount.id === mountId;
      }) || bundle;

    dispatchQuote({
      type: quoteActionTypes.add,
      item: selectedBundle,
    });
    trackCustomEvent({
      category: `Workspace product card`,
      action: `'Add to quote' clicked`,
      label: `${window.location.pathname} - product id ${mountId}`,
    });
    toggleQuote('open');
  };

  return (
    <div className={mergeClassNames(styles.bundleCard, className)} style={style}>
      <MainProduct product={product} addToQuote={mountId => addProduct(mountId)} mounts={productMounts}>
        <BundledProducts products={includedProducts} />
      </MainProduct>
    </div>
  );
}
